import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "22px",
  width: "22px"
}
const _hoisted_2 = ["d"]

interface Props {
  icon?:string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'SogSvgIcon',
  props: {
    icon: { default: undefined }
  },
  setup(__props: any) {



const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", { d: __props.icon }, null, 8, _hoisted_2)
  ]))
}
}

})